import React from "react";
import { Checkbox as AntCheckbox, Form } from "antd";
import { flatten } from "lodash";
import { renderCheckboxes } from "Form/Checkbox";
import * as values from "values";
import { availableSubregion } from "values";
import Map from "Components/Filters/Map";
import { NumberField, TextField } from "Form/InputFields";
import { AnyFilterTypes, FiltersPropTypes, Region, Subregion } from "Types";

export function PropertiesCondition({ formik }: { formik: FiltersPropTypes }): JSX.Element {
    return (
        <Form.Item label={"Stav objektu"}>
            <AntCheckbox.Group className={"rmxo-checkbox-group"}>
                {renderCheckboxes(values.availablePropertiesConditions, "propertiesCondition", formik)}
            </AntCheckbox.Group>
        </Form.Item>
    );
}

export function MapAndLocation({ filter, formik }: { filter: AnyFilterTypes; formik: FiltersPropTypes }): JSX.Element {
    const renderSubregions = (regions?: Region[]): JSX.Element[] => {
        if (!regions) {
            return [];
        }
        const sortedRegions = [...regions].sort((a, b) => a.label.localeCompare(b.label));
        return sortedRegions.map((region) => (
            <Form.Item key={region.id} label={region.label}>
                <AntCheckbox.Group className={"rmxo-checkbox-group"}>
                    {renderCheckboxes(values.availableSubregion[region.id], "subregions", formik)}
                </AntCheckbox.Group>
            </Form.Item>
        ));
    };
    return (
        <>
            <Form.Item label={"Lokalita"}>
                <Map
                    selected={filter.regions}
                    handleClick={(regions: Region[]): void => {
                        formik.setFieldValue("regions", regions);
                        const possibleSubregions = flatten(
                            regions.map((region) => availableSubregion[region.id].map((subregion) => subregion.id))
                        );
                        const newSubregions: Subregion[] = [];
                        formik.values.subregions?.forEach((item) => {
                            if (item && possibleSubregions.includes(item.id)) {
                                newSubregions[item.id] = item;
                            }
                        });
                        // const diff = difference(currentSubregions,possibleSubregions);
                        formik.setFieldValue("subregions", newSubregions);
                    }}
                />
            </Form.Item>
            {renderSubregions(formik.values.regions)}
            <Form.Item label={"Upřesnit lokalitu"}>
                <TextField name={"localityDesc"} placeholder={"Město, městská část, ulice, ..."} />
            </Form.Item>
        </>
    );
}

export function Prices(): JSX.Element {
    return (
        <Form.Item label={"Cena"}>
            <div className={"rmxo-input-inline"}>
                <div>
                    <NumberField name={"priceFrom"} placeholder={"Cena od"} />
                </div>
                <div>
                    <NumberField name={"priceTo"} placeholder={"Cena do"} />
                </div>
            </div>
        </Form.Item>
    );
}

export function Ownership({ formik }: { formik: FiltersPropTypes }): JSX.Element {
    return (
        <Form.Item label={"Vlastnictví"}>
            <AntCheckbox.Group className={"rmxo-checkbox-group"}>
                {renderCheckboxes(values.availableOwnerships, "ownerships", formik)}
            </AntCheckbox.Group>
        </Form.Item>
    );
}

export function TypesOfBuilding({ formik }: { formik: FiltersPropTypes }): JSX.Element {
    return (
        <Form.Item label={"Typ stavby"}>
            <AntCheckbox.Group className={"rmxo-checkbox-group"}>
                {renderCheckboxes(values.availableBuildingTypes, "typesOfBuilding", formik)}
            </AntCheckbox.Group>
        </Form.Item>
    );
}

export function TotalSize(): JSX.Element {
    return (
        <Form.Item label={"Velikost"}>
            <div className={"rmxo-input-inline"}>
                <div>
                    <NumberField name={"sizeTotalFrom"} placeholder={"Velikost od"} />
                </div>
                <div>
                    <NumberField name={"sizeTotalTo"} placeholder={"Velikost do"} />
                </div>
            </div>
        </Form.Item>
    );
}

export function Floors(): JSX.Element {
    return (
        <>
            <Form.Item label={"Patro"}>
                <div className={"rmxo-input-inline"}>
                    <div>
                        <NumberField name={"propertyFloorFrom"} placeholder={"Patro od"} />
                    </div>
                    <div>
                        <NumberField name={"propertyFloorTo"} placeholder={"Patro do"} />
                    </div>
                </div>
            </Form.Item>
        </>
    );
}
